/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_OutboundInputs */

const cs_enum_outbound = /** @type {(inputs: Enum_OutboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odchozí`)
};

const en_enum_outbound = /** @type {(inputs: Enum_OutboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbound`)
};

/**
* | output |
* | --- |
* | "Outbound" |
*
* @param {Enum_OutboundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_outbound = /** @type {((inputs?: Enum_OutboundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_OutboundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_outbound(inputs)
	return cs_enum_outbound(inputs)
});